import http from './api';

const getAgentAvatar = contactId => http.get(`api/avatar/${contactId}`);
const getAgentsAvatarBatch = contactIds => http.post(`api/avatar/batch`, { userIds: contactIds });
const getContactAvatar = contactId => http.get(`api/avatar/contact/${contactId}`);
const getContactsAvatarBatch = contactIds => http.post(`api/avatar/contact/batch`, { userIds: contactIds });

export default {
  getAgentAvatar,
  getAgentsAvatarBatch,
  getContactAvatar,
  getContactsAvatarBatch
};
